import { computed, ref, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-53cfb712"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "refund-modal-title"
}, "¥ 发起退款流程", -1));
const _hoisted_2 = {
  class: "refund-header"
};
const _hoisted_3 = {
  class: "refund-header__col"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "refund-header__label"
}, "订单总额", -1));
const _hoisted_5 = {
  class: "refund-header__amount"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "refund-header__divider"
}, null, -1));
const _hoisted_7 = {
  class: "refund-header__col refund-header__col--right"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "refund-header__label"
}, "用户申退", -1));
const _hoisted_9 = {
  class: "refund-header__amount"
};
const _hoisted_10 = {
  class: "amount-input"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "amount-input__prefix"
}, "¥", -1));
const _hoisted_12 = {
  class: "refund-reason-label"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "refund-reason-label__text"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "refund-reason-label__required"
}, "*"), /*#__PURE__*/_createTextVNode(" 退款原因 ")], -1));
const _hoisted_14 = {
  class: "refund-reason-label__tags"
};
const _hoisted_15 = {
  class: "screenshot-upload"
};
const _hoisted_16 = {
  key: 0,
  class: "screenshot-upload__loading"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  class: "screenshot-upload__trigger"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上传", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "screenshot-upload__hint"
}, "支持 PNG, JPG 格式，最多 3 张，可直接 Ctrl+V 粘贴截图", -1));
const _hoisted_21 = {
  key: 0,
  class: "refund-header"
};
const _hoisted_22 = {
  class: "refund-header__col"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "refund-header__label"
}, "订单总额", -1));
const _hoisted_24 = {
  class: "refund-header__amount"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "refund-header__divider"
}, null, -1));
const _hoisted_26 = {
  class: "refund-header__col refund-header__col--right"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "refund-header__label"
}, "订单数", -1));
const _hoisted_28 = {
  class: "refund-header__amount"
};
const _hoisted_29 = {
  class: "screenshot-upload"
};
const _hoisted_30 = {
  key: 0,
  class: "screenshot-upload__loading"
};
const _hoisted_31 = ["onClick"];
const _hoisted_32 = {
  class: "screenshot-upload__trigger"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上传", -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "screenshot-upload__hint"
}, "支持 PNG, JPG 格式，最多 3 张，可直接 Ctrl+V 粘贴截图", -1));
const _hoisted_35 = {
  class: "batch-reply-editor__header"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "统一回复内容", -1));
const _hoisted_37 = {
  key: 0,
  class: "batch-reply-editor__files"
};
const _hoisted_38 = ["onClick"];
const _hoisted_39 = {
  class: "batch-reply-editor__tools"
};
const _hoisted_40 = {
  class: "batch-reply-editor__left-tools"
};
const _hoisted_41 = {
  class: "batch-template-dropdown"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "batch-template-dropdown__header"
}, "选择快捷回复", -1));
const _hoisted_43 = {
  class: "batch-template-menu__title"
};
const _hoisted_44 = {
  class: "batch-template-menu__content"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "batch-reply-editor__limit"
}, "最多4张", -1));
const _hoisted_46 = {
  class: "batch-reply-editor__count"
};
import { onMounted, onBeforeUnmount } from 'vue';
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ActionModals',
  props: {
    refundOpen: {
      type: Boolean
    },
    rejectOpen: {
      type: Boolean
    },
    batchOpen: {
      type: Boolean
    },
    submitLoading: {
      type: Boolean
    },
    complaint: null,
    selectedCount: null,
    batchTotalAmount: null,
    batchType: null,
    refundAmount: null,
    refundReason: null,
    rejectReason: null,
    batchRefundMode: null,
    batchRefundRatio: null,
    batchRefundReason: null,
    batchReplyContent: null,
    batchReplyFiles: null,
    refundScreenshots: null,
    refundReasons: null,
    replyTemplates: null,
    toMoney: null,
    beforeUploadImage: null,
    beforeUploadRefundScreenshot: null
  },
  emits: ["update:refundOpen", "update:rejectOpen", "update:batchOpen", "update:refundAmount", "update:refundReason", "update:rejectReason", "update:batchRefundMode", "update:batchRefundRatio", "update:batchRefundReason", "update:batchReplyContent", "fill-full-refund", "submit-refund", "submit-reject", "submit-batch", "paste-batch-reply-image", "remove-file", "paste-refund-screenshot", "remove-refund-screenshot"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const handleGlobalPaste = e => {
      var _e$clipboardData;
      const isBatchRefund = props.batchOpen && props.batchType === 'refund';
      if ((props.refundOpen || isBatchRefund) && (_e$clipboardData = e.clipboardData) !== null && _e$clipboardData !== void 0 && (_e$clipboardData = _e$clipboardData.files) !== null && _e$clipboardData !== void 0 && _e$clipboardData.length) emit('paste-refund-screenshot', e);
    };
    onMounted(() => document.addEventListener('paste', handleGlobalPaste));
    onBeforeUnmount(() => document.removeEventListener('paste', handleGlobalPaste));
    const batchTitle = computed(() => ({
      refund: '批量发起退款确认',
      reply: '批量回复选定用户',
      finish: '批量完结'
    })[props.batchType]);
    const refundReasonTouched = ref(false);
    const screenshotTouched = ref(false);
    const refundReasonError = computed(() => refundReasonTouched.value && !props.refundReason.trim());
    const screenshotError = computed(() => screenshotTouched.value && !props.refundScreenshots.length);
    const handleRefundReasonChange = value => {
      emit('update:refundReason', value);
      if (value.trim()) refundReasonTouched.value = false;
    };
    const handleRefundOk = () => {
      if (!props.refundReason.trim()) {
        refundReasonTouched.value = true;
        return;
      }
      if (!props.refundScreenshots.length) {
        screenshotTouched.value = true;
        return;
      }
      emit('submit-refund');
    };
    const batchRefundRatioTouched = ref(false);
    const batchRefundReasonTouched = ref(false);
    const batchReplyContentTouched = ref(false);
    const batchScreenshotTouched = ref(false);
    const batchScreenshotError = computed(() => props.batchType === 'refund' && batchScreenshotTouched.value && !props.refundScreenshots.length);
    const batchRefundRatioError = computed(() => props.batchType === 'refund' && props.batchRefundMode === 'ratio' && batchRefundRatioTouched.value && !props.batchRefundRatio);
    const batchRefundReasonError = computed(() => props.batchType === 'refund' && batchRefundReasonTouched.value && !props.batchRefundReason.trim());
    const batchReplyContentError = computed(() => props.batchType === 'reply' && batchReplyContentTouched.value && props.batchReplyContent.trim().length < 10);
    const handleBatchRefundModeChange = value => {
      emit('update:batchRefundMode', value);
      batchRefundRatioTouched.value = false;
      if (value === 'ratio') emit('update:batchRefundRatio', undefined);
    };
    const handleBatchRefundRatioChange = value => {
      emit('update:batchRefundRatio', value);
      if (value) batchRefundRatioTouched.value = false;
    };
    const handleBatchRefundReasonChange = value => {
      emit('update:batchRefundReason', value);
      if (value.trim()) batchRefundReasonTouched.value = false;
    };
    const handleBatchReplyContentChange = value => {
      emit('update:batchReplyContent', value);
      if (value.trim().length >= 10) batchReplyContentTouched.value = false;
    };
    const getTemplateTitle = content => {
      const firstCommaIndex = content.search(/[，,。.\s]/);
      const endIndex = firstCommaIndex > 0 ? firstCommaIndex : Math.min(content.length, 12);
      return content.slice(0, endIndex);
    };
    const handleBatchOk = () => {
      if (props.batchType === 'reply' && props.batchReplyContent.trim().length < 10) {
        batchReplyContentTouched.value = true;
        return;
      }
      if (props.batchType === 'refund' && props.batchRefundMode === 'ratio' && !props.batchRefundRatio) {
        batchRefundRatioTouched.value = true;
        return;
      }
      if (props.batchType === 'refund' && !props.batchRefundReason.trim()) {
        batchRefundReasonTouched.value = true;
        return;
      }
      if (props.batchType === 'refund' && !props.refundScreenshots.length) {
        batchScreenshotTouched.value = true;
        return;
      }
      emit('submit-batch');
    };
    watch(() => props.refundOpen, () => {
      refundReasonTouched.value = false;
      screenshotTouched.value = false;
    });
    watch(() => [props.batchOpen, props.batchType], () => {
      batchRefundRatioTouched.value = false;
      batchRefundReasonTouched.value = false;
      batchReplyContentTouched.value = false;
      batchScreenshotTouched.value = false;
    });
    return (_ctx, _cache) => {
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_image = _resolveComponent("a-image");
      const _component_a_upload = _resolveComponent("a-upload");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      const _component_a_alert = _resolveComponent("a-alert");
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_image_preview_group = _resolveComponent("a-image-preview-group");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_a_modal, {
        open: __props.refundOpen,
        "confirm-loading": __props.submitLoading,
        "ok-text": "提交审批",
        "ok-button-props": {
          danger: true
        },
        onOk: handleRefundOk,
        onCancel: _cache[2] || (_cache[2] = $event => emit('update:refundOpen', false))
      }, {
        title: _withCtx(() => [_hoisted_1]),
        default: _withCtx(() => {
          var _props$complaint, _props$complaint2;
          return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, "¥" + _toDisplayString(__props.toMoney((_props$complaint = __props.complaint) === null || _props$complaint === void 0 ? void 0 : _props$complaint.amount)), 1)]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, _toDisplayString((_props$complaint2 = __props.complaint) !== null && _props$complaint2 !== void 0 && _props$complaint2.applyRefundAmount ? `¥${__props.toMoney(__props.complaint.applyRefundAmount)}` : '未明确'), 1)])]), _createVNode(_component_a_form, {
            layout: "vertical"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "退款金额",
              required: ""
            }, {
              default: _withCtx(() => {
                var _props$complaint3, _props$complaint4;
                return [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_a_input_number, {
                  value: __props.refundAmount,
                  min: 0.01,
                  max: Number(((_props$complaint3 = __props.complaint) === null || _props$complaint3 === void 0 ? void 0 : _props$complaint3.amount) || 0),
                  controls: false,
                  placeholder: `最多可退 ${__props.toMoney((_props$complaint4 = __props.complaint) === null || _props$complaint4 === void 0 ? void 0 : _props$complaint4.amount)}`,
                  style: {
                    "flex": "1"
                  },
                  "onUpdate:value": _cache[0] || (_cache[0] = $event => emit('update:refundAmount', Number($event || 0)))
                }, null, 8, ["value", "min", "max", "placeholder"]), _createElementVNode("span", {
                  class: "amount-input__suffix",
                  onClick: _cache[1] || (_cache[1] = $event => emit('fill-full-refund'))
                }, "全额")])];
              }),
              _: 1
            }), _createVNode(_component_a_form_item, {
              "validate-status": _unref(refundReasonError) ? 'error' : '',
              help: _unref(refundReasonError) ? '请输入退款原因' : ''
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.refundReasons, item => {
                return _openBlock(), _createBlock(_component_a_tag, {
                  key: item,
                  onClick: $event => emit('update:refundReason', item)
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
                  _: 2
                }, 1032, ["onClick"]);
              }), 128))])]), _createVNode(_component_a_textarea, {
                value: __props.refundReason,
                maxlength: 200,
                rows: 4,
                placeholder: "请输入退款原因，该原因将同步至微信支付平台...",
                "onUpdate:value": handleRefundReasonChange
              }, null, 8, ["value"])]),
              _: 1
            }, 8, ["validate-status", "help"]), _createVNode(_component_a_form_item, {
              required: "",
              "validate-status": _unref(screenshotError) ? 'error' : '',
              help: _unref(screenshotError) ? '请至少上传一张客诉截图' : ''
            }, {
              label: _withCtx(() => [_createTextVNode("客诉截图")]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.refundScreenshots, file => {
                return _openBlock(), _createElementBlock("div", {
                  key: file.uid,
                  class: "screenshot-upload__item"
                }, [file.status === 'uploading' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_unref(LoadingOutlined))])) : (_openBlock(), _createElementBlock(_Fragment, {
                  key: 1
                }, [_createVNode(_component_a_image, {
                  src: file.url,
                  width: 72,
                  height: 72,
                  style: {
                    "object-fit": "cover"
                  }
                }, null, 8, ["src"]), _createElementVNode("button", {
                  class: "screenshot-upload__remove",
                  type: "button",
                  onClick: $event => emit('remove-refund-screenshot', file)
                }, " × ", 8, _hoisted_17)], 64))]);
              }), 128)), __props.refundScreenshots.length < 3 ? (_openBlock(), _createBlock(_component_a_upload, {
                key: 0,
                "before-upload": __props.beforeUploadRefundScreenshot,
                "show-upload-list": false,
                accept: ".png,.jpg,.jpeg"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_unref(PlusOutlined)), _hoisted_19])]),
                _: 1
              }, 8, ["before-upload"])) : _createCommentVNode("", true)]), _hoisted_20]),
              _: 1
            }, 8, ["validate-status", "help"])]),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["open", "confirm-loading"]), _createVNode(_component_a_modal, {
        open: __props.rejectOpen,
        title: "处理完成",
        "confirm-loading": __props.submitLoading,
        onOk: _cache[4] || (_cache[4] = $event => emit('submit-reject')),
        onCancel: _cache[5] || (_cache[5] = $event => emit('update:rejectOpen', false))
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          layout: "vertical"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "完成原因"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_textarea, {
              value: __props.rejectReason,
              maxlength: 200,
              rows: 4,
              placeholder: "请输入处理完成说明",
              "onUpdate:value": _cache[3] || (_cache[3] = $event => emit('update:rejectReason', $event))
            }, null, 8, ["value"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["open", "confirm-loading"]), _createVNode(_component_a_modal, {
        open: __props.batchOpen,
        title: _unref(batchTitle),
        "confirm-loading": __props.submitLoading,
        "ok-text": __props.batchType === 'finish' ? '确认完结' : __props.batchType === 'reply' ? '确认回复' : '提交审批',
        "cancel-text": "取消",
        onOk: handleBatchOk,
        onCancel: _cache[8] || (_cache[8] = $event => emit('update:batchOpen', false))
      }, {
        default: _withCtx(() => [__props.batchType === 'refund' ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, "¥" + _toDisplayString(__props.toMoney(__props.batchTotalAmount)), 1)]), _hoisted_25, _createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("div", _hoisted_28, _toDisplayString(__props.selectedCount), 1)])])) : _createCommentVNode("", true), __props.batchType === 'reply' ? (_openBlock(), _createBlock(_component_a_alert, {
          key: 1,
          type: "info",
          "show-icon": "",
          message: `本次将统一回复 ${__props.selectedCount} 条投诉单`
        }, null, 8, ["message"])) : _createCommentVNode("", true), __props.batchType === 'finish' ? (_openBlock(), _createBlock(_component_a_alert, {
          key: 2,
          type: "warning",
          "show-icon": "",
          message: "确认投诉已妥善处理后再结单，否则用户可能会重复投诉并引发升级风险。"
        })) : _createCommentVNode("", true), _createVNode(_component_a_form, {
          layout: "vertical",
          class: "batch-form"
        }, {
          default: _withCtx(() => [__props.batchType === 'refund' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_a_form_item, {
            label: "统一退款金额",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_radio_group, {
              value: __props.batchRefundMode,
              "onUpdate:value": handleBatchRefundModeChange
            }, {
              default: _withCtx(() => [_createVNode(_component_a_radio, {
                value: "full"
              }, {
                default: _withCtx(() => [_createTextVNode("全额退款")]),
                _: 1
              }), _createVNode(_component_a_radio, {
                value: "ratio"
              }, {
                default: _withCtx(() => [_createTextVNode("按比例退款")]),
                _: 1
              })]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }), __props.batchRefundMode === 'ratio' ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 0,
            label: "退款比例",
            required: "",
            "validate-status": _unref(batchRefundRatioError) ? 'error' : '',
            help: _unref(batchRefundRatioError) ? '请输入退款比例' : ''
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_number, {
              value: __props.batchRefundRatio,
              min: 1,
              max: 99,
              "addon-after": "%",
              placeholder: "请输入退款比例(例如50)",
              style: {
                "width": "100%"
              },
              "onUpdate:value": handleBatchRefundRatioChange
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["validate-status", "help"])) : _createCommentVNode("", true), _createVNode(_component_a_form_item, {
            label: "统一退款原因",
            required: "",
            "validate-status": _unref(batchRefundReasonError) ? 'error' : '',
            help: _unref(batchRefundReasonError) ? '请输入统一退款原因' : ''
          }, {
            default: _withCtx(() => [_createVNode(_component_a_textarea, {
              value: __props.batchRefundReason,
              maxlength: 200,
              rows: 4,
              placeholder: "请输入统一退款原因，将同步至微信支付平台...",
              "onUpdate:value": handleBatchRefundReasonChange
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["validate-status", "help"]), _createVNode(_component_a_form_item, {
            required: "",
            "validate-status": _unref(batchScreenshotError) ? 'error' : '',
            help: _unref(batchScreenshotError) ? '请至少上传一张客诉截图' : ''
          }, {
            label: _withCtx(() => [_createTextVNode("客诉截图")]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.refundScreenshots, file => {
              return _openBlock(), _createElementBlock("div", {
                key: file.uid,
                class: "screenshot-upload__item"
              }, [file.status === 'uploading' ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createVNode(_unref(LoadingOutlined))])) : (_openBlock(), _createElementBlock(_Fragment, {
                key: 1
              }, [_createVNode(_component_a_image, {
                src: file.url,
                width: 72,
                height: 72,
                style: {
                  "object-fit": "cover"
                }
              }, null, 8, ["src"]), _createElementVNode("button", {
                class: "screenshot-upload__remove",
                type: "button",
                onClick: $event => emit('remove-refund-screenshot', file)
              }, " × ", 8, _hoisted_31)], 64))]);
            }), 128)), __props.refundScreenshots.length < 3 ? (_openBlock(), _createBlock(_component_a_upload, {
              key: 0,
              "before-upload": __props.beforeUploadRefundScreenshot,
              "show-upload-list": false,
              accept: ".png,.jpg,.jpeg"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createVNode(_unref(PlusOutlined)), _hoisted_33])]),
              _: 1
            }, 8, ["before-upload"])) : _createCommentVNode("", true)]), _hoisted_34]),
            _: 1
          }, 8, ["validate-status", "help"])], 64)) : _createCommentVNode("", true), __props.batchType === 'reply' ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 1,
            "validate-status": _unref(batchReplyContentError) ? 'error' : '',
            help: _unref(batchReplyContentError) ? '回复内容需10-200字' : ''
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(["batch-reply-editor", {
                'batch-reply-editor--error': _unref(batchReplyContentError)
              }])
            }, [_createElementVNode("div", _hoisted_35, [_createVNode(_component_svg_icon, {
              "icon-class": "replay",
              "class-name": "batch-reply-editor__icon"
            }), _hoisted_36]), _createVNode(_component_a_textarea, {
              value: __props.batchReplyContent,
              maxlength: 200,
              rows: 4,
              placeholder: "请输入回复内容，至少10个字...",
              onPaste: _cache[6] || (_cache[6] = $event => emit('paste-batch-reply-image', $event)),
              "onUpdate:value": handleBatchReplyContentChange
            }, null, 8, ["value"]), __props.batchReplyFiles.length ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createVNode(_component_a_image_preview_group, null, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.batchReplyFiles, file => {
                return _openBlock(), _createElementBlock("div", {
                  key: file.uid,
                  class: "batch-reply-editor__thumb"
                }, [_createVNode(_component_a_image, {
                  src: file.url,
                  width: 56,
                  height: 56
                }, null, 8, ["src"]), _createElementVNode("button", {
                  class: "batch-reply-editor__remove",
                  type: "button",
                  onClick: $event => emit('remove-file', file)
                }, [_createVNode(_component_svg_icon, {
                  "icon-class": "close",
                  "class-name": "batch-reply-editor__remove-icon"
                })], 8, _hoisted_38)]);
              }), 128))]),
              _: 1
            })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createVNode(_component_a_dropdown, {
              placement: "topLeft",
              trigger: ['click']
            }, {
              overlay: _withCtx(() => [_createElementVNode("div", _hoisted_41, [_hoisted_42, _createVNode(_component_a_menu, {
                class: "batch-template-menu",
                onClick: _cache[7] || (_cache[7] = item => handleBatchReplyContentChange(item.key))
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.replyTemplates, item => {
                  return _openBlock(), _createBlock(_component_a_menu_item, {
                    key: item
                  }, {
                    default: _withCtx(() => [_createElementVNode("div", _hoisted_43, _toDisplayString(getTemplateTitle(item)), 1), _createElementVNode("div", _hoisted_44, _toDisplayString(item), 1)]),
                    _: 2
                  }, 1024);
                }), 128))]),
                _: 1
              })])]),
              default: _withCtx(() => [_createVNode(_component_a_button, {
                size: "small",
                type: "text"
              }, {
                icon: _withCtx(() => [_createVNode(_component_svg_icon, {
                  "icon-class": "replay",
                  "class-name": "batch-reply-editor__tool-icon"
                })]),
                default: _withCtx(() => [_createTextVNode(" 快捷模版 ")]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_upload, {
              "before-upload": __props.beforeUploadImage,
              "show-upload-list": false,
              accept: "image/*"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_button, {
                size: "small",
                type: "text",
                disabled: __props.batchReplyFiles.length >= 4
              }, {
                icon: _withCtx(() => [_createVNode(_component_svg_icon, {
                  "icon-class": "upload_stencil",
                  "class-name": "batch-reply-editor__tool-icon"
                })]),
                default: _withCtx(() => [_createTextVNode(" 添加图片 "), _hoisted_45]),
                _: 1
              }, 8, ["disabled"])]),
              _: 1
            }, 8, ["before-upload"])]), _createElementVNode("span", _hoisted_46, _toDisplayString(__props.batchReplyContent.length) + "/200", 1)])], 2)]),
            _: 1
          }, 8, ["validate-status", "help"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["open", "title", "confirm-loading", "ok-text"])], 64);
    };
  }
});